<template>
    <div>
        <h2><router-link :to="{ name: 'product' }">สินค้าทั้งหมด</router-link> > {{ $store.getters['app/GET_APP_MODE'] == 'create' ? "เพิ่ม" : "แก้ไข"}}สินค้า</h2>
        <v-card class="mt-4">
            <v-tabs
            v-model="selectedTab"
            >
            <v-tabs-slider color="primary"></v-tabs-slider>

                <v-tab
                    v-for="(tab, tab_index) in tabs"
                    :key="tab"
                >
                    <v-icon class="mr-2">{{ getIcon(tab_index) }}</v-icon> {{ tab }}
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="selectedTab" class="pa-8">
                <v-form v-model="isFormValid">
                  <v-tab-item
                      key="ข้อมูลสินค้า"
                  >
                      <basic-product-info
                      v-model="formData"
                      />
                  </v-tab-item>

                  <v-tab-item
                      key="ขั้นสูง"
                  >
                      <advance-product-info v-model="formData" />
                  </v-tab-item>

                  <v-tab-item
                    key="shopee"
                  >
                    <shopee
                    :parentData="formData"
                    v-model="shopeeFormData"
                    ></shopee>
                  </v-tab-item>

                  <v-tab-item
                    key="tiktok"
                  >
                    <tiktok
                    :parentData="formData"
                    v-model="tiktokFormData"
                    ></tiktok>
                  </v-tab-item>
                </v-form>
            </v-tabs-items>

            <v-dialog
              transition="dialog-top-transition"
              max-width="600"
              v-model="confirmationModal"
            >
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                  class="text-h4"
                >โปรดอ่าน</v-toolbar>
                <v-card-text>
                  <v-container class="pt-10">
                    <v-row>
                      <v-col>
                        <label  class="text-h6">เนื่องจากสินค้าชนิดนี้มีการเชื่อมต่อกับ Platform อื่น ๆ ตามที่ระบุด้านล่าง หากท่านต้องการอัพเดธข้อมูลในที่อื่นด้วย โปรดระบุด้านล่าง</label>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-checkbox
                          v-if="isSyncedShopee"
                          :key="'sync_shopee'"
                          label="ต้องการอัพเดธข้อมูลบน Shopee"
                          v-model="sync_shopee"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col>
                        <v-checkbox
                          v-if="isSyncedTiktok"
                          :key="'sync_tiktok'"
                          label="ต้องการอัพเดธข้อมูลบน Tiktok"
                          v-model="sync_tiktok"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="secondary"
                    outlined
                    large
                    :disabled="sendingData"
                    @click="confirmationModal = false"
                  >
                    ยกเลิก
                  </v-btn>

                  <v-btn
                    color="primary"
                    large
                    :disabled="!isFormValid"
                    :loading="sendingData"
                    @click="submitForm"
                    v-if="$store.getters['app/GET_APP_MODE'] != 'read'"
                  >
                    แก้ไข
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

             <v-card-actions class="justify-end">
              <v-btn
                color="secondary"
                outlined
                large
                :disabled="sendingData"
                @click="$router.go(-1)"
              >
                กลับ
              </v-btn>
              <v-btn
                color="primary"
                large
                :disabled="!isFormValid"
                :loading="sendingData"
                @click="isConfirmationRequired ? confirmationModal = true : submitForm()"
                v-if="$store.getters['app/GET_APP_MODE'] != 'read'"
              >
                {{ $store.getters['app/GET_APP_MODE'] == 'create' ? "สร้าง" : "แก้ไข"}}
              </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
import { asyncGet, asyncPostAsJson } from '@/helpers/asyncAxios'
import {
  convertAttributesAndTermsFromServerToForm,
  convertDataFromServerToDelayAutoSelect,
  convertDelayAutoSelectValueToServer,
  convertFromServerToVueFileAgent,
  convertFromVueFileAgentToServer,
  convertInventoryDataFromServerToForm,
  convertVariationFromServerToForm,
} from '@/helpers/converter'
import { mdiArchiveOutline, mdiBookmarkOutline, mdiDotsHorizontal, mdiLockOpenOutline } from '@mdi/js'
import AdvanceProductInfo from './components/AdvanceProductInfo.vue'
import BasicProductInfo from './components/BasicProductInfo.vue'
import Shopee from './components/Shopee'
import Tiktok from './components/Tiktok'
import errorParser from '@/plugins/errorparser'
export default {
  data() {
    return {
      confirmationModal: false,
      isFormValid: false,
      sendingData: false,
      originalImages: [],
      formData: {
        /* BASIC PRODUCT PROPERTIES */
        images: [
          /*
          {
            name: 'asdsadas.png',
            ext: 'png',
            type: 'image',
            size: 1,
            url: 'https://aoodrive.sgp1.digitaloceanspaces.com/images/I8U9MV3GBCpWrAEVPBAElrsjclQ3ZYSD5egLg3LW.png',
            upload: {
              data: {
                id: 99,
                hash: 'eb2e16ce66c7407dcd79693a2c4a791b2cd3b224cdfb69ca03e6c34490bec468',
                lazada_id: null,
                shopee_id: null,
                URI: 'https://aoodrive.sgp1.digitaloceanspaces.com/images/I8U9MV3GBCpWrAEVPBAElrsjclQ3ZYSD5egLg3LW.png',
                created_at: '2022-08-23T22:57:10.000000Z',
                updated_at: '2022-08-23T22:57:10.000000Z',
                lastaccess_at: null,
                deleted_at: null,
              },
            },
          },
          */
        ],
        name: null,
        categories: [],
        brand: null,
        tags: [],
        isVariable: false,
        defaultCost: null,
        defaultPrice: null,
        discountedPrice: null,
        sku: null,
        barCode: null,
        attributes: [],
        variations: [],
        /* ADVANCE PRODUCT PROPERTIES */
        unit: null,
        package_weight: null,
        package_width: null,
        package_length: null,
        package_height: null,
        stock: false,
        is_vat: false,
        stockInfo: [],
      },
      sync_shopee: false,
      sync_tiktok: false,
      shopeeFormData: {
        salechannel: null,
        shopee_salechannel_id: null,
        shopee_product_id: null,
        name: null,
        condition: 'NEW',
        description: null,
        original_price: null,
        current_price: null,
        brand: null,
        attribute_list: [],
        category_id: null,
        logistic_info: [],
      },
      originalShopeeFormData: null,
      tiktokFormData: {
        salechannel: null,
        tiktok_salechannel_id: null,
        tiktok_prorduct_id: null,
        name: null,
        description: null,
        original_price: null,
        current_price: null,
        category_id: null,
        sale_attributes: [],
      },
      selectedTab: null,
      tabs: ['ข้อมูลสินค้า', 'ขั้นสูง', 'shopee', 'tiktok'],
      tabIcons: [mdiArchiveOutline, mdiDotsHorizontal, mdiLockOpenOutline, mdiBookmarkOutline],
    }
  },
  watch: {
    'formData.isVariable': function (value) {
      if (!value) this.formData.variations = []
    },
    'formData.variations': function (value) {
      const shopeeFormData = this.shopeeFormData

      if (this.shopeeFormData.model) {
        console.log(this.shopeeFormData.model)
        const newVariations = JSON.parse(JSON.stringify(this.formData.variations)).map(item => {
          const modelData = shopeeFormData.model.find(model => model.model_id == item.shopee_model_id)

          //get TH price

          if (!modelData)
            return {
              ...item,
              defaultPrice: null,
            }

          const price_info = modelData.price_info.find(price_info => price_info.currency == 'THB')

          const price = price_info ? price_info.original_price : modelData.price_info[0].original_price // If no TH price, use top price

          return {
            ...item,
            defaultPrice: price,
          }
        })

        this.shopeeFormData.variations = newVariations
      } else {
        this.shopeeFormData.variations = JSON.parse(JSON.stringify(this.formData.variations))
      }

      if (this.tiktokFormData.skus) {
        const tiktokFormData = this.tiktokFormData

        const { variations } = this.formData

        const newVariations = JSON.parse(JSON.stringify(variations)).map(item => {
          const modelData = tiktokFormData.skus.find(model => model.id == item.tiktok_model_id)

          if (!modelData) {
            // This means this Variation is not available in 3rd party platform for some reasons.
            return {
              ...item,
              notSync: true,
            }
          }

          const price = modelData.price.sale_price

          return {
            ...item,
            defaultPrice: price,
          }
        })

        this.tiktokFormData.variations = newVariations
      } else {
        this.tiktokFormData.variations = JSON.parse(JSON.stringify(this.formData.variations))
      }
    },
  },
  computed: {
    isSyncedShopee() {
      return !!this.shopeeFormData.salechannel
    },
    isSyncedTiktok() {
      return !!this.tiktokFormData.salechannel
    },
    isConfirmationRequired() {
      if (this.$store.getters['app/GET_APP_MODE'] == 'create') return false

      return this.isSyncedShopee || this.isSyncedTiktok
    },
  },
  async created() {
    const product_id = this.$route.params.product_id

    if (product_id == 'create') {
      this.$store.commit('app/SET_APP_MODE', 'create')
      return
    } else if (this.$store.getters['auth/GET_ABILITY'].can('update', 'Product'))
      this.$store.commit('app/SET_APP_MODE', 'edit')
    else this.$store.commit('app/SET_APP_MODE', 'read')

    this.$store.commit('app/SET_GLOBAL_LOADING', true)
    try {
      const response = await asyncGet('/product/' + product_id)

      this.convertDataFromServerToForm(response)

      if (response.shopee_salechannel_id) {
        // Already Linked with Shopee
        try {
          await this.getShopeeData(product_id, response.shopee_salechannel_id, response.shopee_product_id)
        } catch (shopeeErr) {
          this.$root.showCommonDialog('มีปัญหา', 'SHOPEE:' + errorParser(shopeeErr))
        }
      }

      if (response.tiktok_salechannel_id) {
        // Already Linked with Tiktok
        try {
          await this.getTiktokData(product_id, response.tiktok_salechannel_id, response.tiktok_product_id)
        } catch (tiktokErr) {
          this.$root.showCommonDialog('มีปัญหา', 'TIKTOK:' + errorParser(tiktokErr))
        }
      }
    } catch (error) {
      this.$root.showCommonDialog('มีปัญหา', errorParser(error))
    }
    this.$store.commit('app/SET_GLOBAL_LOADING', false)
  },
  methods: {
    getIcon(index) {
      return this.tabIcons[index]
    },
    async submitForm() {
      this.sendingData = true
      try {
        /*
        START OF HOTFIX SECTION

        Because VueFileAgent limitation when upload addition images for products, we need code in this section for preventing data loss
        */
        const originalImages = this.originalImages

        const formattedImages = this.formData.images.map(image => {
          if (!!image.upload.data) return image

          const found = originalImages.find(item => item.URI == image.urlResized)

          if (!found) return

          return {
            ...image,
            upload: {
              data: found,
            },
          }
        })
        /*
        END OF HOTFIX SECTION
        */

        const sendData = {
          ...this.formData,
          images: convertFromVueFileAgentToServer(formattedImages),
          tags: convertDelayAutoSelectValueToServer(this.formData.tags),
          categories: convertDelayAutoSelectValueToServer(this.formData.categories),
          brand_id: convertDelayAutoSelectValueToServer(this.formData.brand),
          variations: this.formData.variations.map(data => {
            return {
              ...data,
              image: convertFromVueFileAgentToServer(data.image),
            }
          }),
        }

        if (this.$store.getters['app/GET_APP_MODE'] == 'create') {
          sendData['shopee'] = this.shopeeFormData
          sendData['tiktok'] = this.tiktokFormData
        } else {
          if (this.sync_shopee) {
            sendData['shopee'] = this.shopeeFormData
          }

          if (this.sync_tiktok) {
            sendData['tiktok'] = this.tiktokFormData
          }
        }

        const product_id = this.$route.params.product_id
        if (product_id == 'create') await asyncPostAsJson('/product', sendData)
        else {
          sendData['_method'] = 'PUT'
          await asyncPostAsJson('/product/' + product_id, sendData)
        }

        this.$router.push({ name: 'product' })
      } catch (error) {
        console.log(error)
        this.$root.showCommonDialog('มีปัญหา', error)
      }

      this.sendingData = false
    },
    convertDataFromServerToForm(data) {
      const attributes = convertAttributesAndTermsFromServerToForm(data.attributes, data.terms)
      const variations = convertVariationFromServerToForm(attributes, data.variations)
      const stockInfo =
        variations.length > 0
          ? convertInventoryDataFromServerToForm(variations)
          : data.inventory.map(item => {
              return {
                id: item.warehouse_id,
                quantity: item.quantity - item.reserved,
              }
            })
      this.formData = {
        name: data.name,
        images: convertFromServerToVueFileAgent(data.images),
        categories: convertDataFromServerToDelayAutoSelect(data.categories),
        brand: convertDataFromServerToDelayAutoSelect(data.brand),
        tags: convertDataFromServerToDelayAutoSelect(data.tags),
        isVariable: data.product_type == 'variable' ? true : false,
        defaultCost: data.defaultCost,
        defaultPrice: data.defaultPrice,
        discountedPrice: data.discountedPrice,
        sku: data.sku,
        barCode: data.barCode,
        attributes: attributes,
        variations: variations,
        /* ADVANCE PRODUCT PROPERTIES */
        unit: data.unit,
        package_weight: data.package_weight,
        package_width: data.package_width,
        package_length: data.package_length,
        package_height: data.package_height,
        stock: data.stock,
        is_vat: data.is_vat,
        stockInfo: stockInfo,
      }

      this.originalImages = data.images

      // console.log(this.formData)
    },
    async getShopeeData(product_id, shopee_salechannel_id, shopee_product_id) {
      const { product_detail, model_response, salechannel } = await asyncGet('/product/' + product_id + '/shopee')

      const {
        item_name,
        logistic_info,
        category_id,
        condition,
        item_status,
        brand,
        description,
        description_info,
        description_type,
        attribute_list,
        price_info,
        attributes,
      } = product_detail

      const price = price_info ? price_info.find(item => item.currency == 'THB') : false

      const original_price = price ? price.original_price : 0

      let descriptionText = null

      if (description_type == 'extended') {
        const descriptionObject = description_info.extended_description.field_list.find(
          item => item.field_type == 'text',
        )

        descriptionText = descriptionObject.text
      } else descriptionText = description

      const { variations } = this.formData

      const newVariations = JSON.parse(JSON.stringify(variations)).map(item => {
        const modelData = model_response.model.find(model => model.model_id == item.shopee_model_id)

        //get TH price

        const price_info = modelData.price_info.find(price_info => price_info.currency == 'THB')

        const price = price_info ? price_info.original_price : modelData.price_info[0].original_price // If no TH price, use top price

        return {
          ...item,
          defaultPrice: price,
        }
      })

      this.shopeeFormData = {
        salechannel: salechannel,
        unlink: false,
        shopee_salechannel_id: shopee_salechannel_id,
        shopee_product_id: shopee_product_id,
        name: item_name,
        condition: condition,
        description: descriptionText,
        description_type: description_type,
        description_info: description_info,
        original_price: original_price,
        brand: brand,
        //attributes: attributes, // Shopee's not aoo
        attribute_list: attribute_list
          ? attribute_list.map(item => {
              return {
                ...item,
                value: null,
              }
            })
          : null,
        category_id: category_id,
        logistic_info: logistic_info,

        variations: newVariations,
        model: model_response ? model_response.model : null,
      }
    },
    async getTiktokData(product_id, tiktok_salechannel_id, tiktok_product_id) {
      const { product_detail, salechannel } = await asyncGet('/product/' + product_id + '/tiktok')

      const { title, description, skus, category_chains, product_attributes } = product_detail

      const { variations } = this.formData

      const original_price = skus[0].price.sale_price
      const sale_attributes = [...new Set(skus.map(obj => obj.id))]

      const newVariations = JSON.parse(JSON.stringify(variations)).map(item => {
        const modelData = skus.find(model => model.id == item.tiktok_model_id)

        if (!modelData) {
          // This means this Variation is not available in 3rd party platform for some reasons.
          return {
            ...item,
            notSync: true,
          }
        }

        const price = modelData.price.sale_price

        return {
          ...item,
          defaultPrice: price,
        }
      })

      const category_id = category_chains.find(item => item.is_leaf).id

      this.tiktokFormData = {
        salechannel: salechannel,
        unlink: false,
        tiktok_salechannel_id: tiktok_salechannel_id,
        tiktok_product_id: tiktok_product_id,
        name: title,
        description: description,
        original_price: original_price,
        /*
        attribute_list: attribute_list
          ? attribute_list.map(item => {
              return {
                ...item,
                value: null,
              }
            })
          : null,
        */
        category_id: category_id,
        variations: newVariations,
        skus: skus,
        attributes: product_attributes
          ? product_attributes.map(item => {
              return {
                ...item,
                value: item.values,
              }
            })
          : [],
        sale_attributes: sale_attributes,
      }
    },
  },
  components: {
    BasicProductInfo,
    AdvanceProductInfo,
    Shopee,
    Tiktok,
  },
}
</script>
